import { render, staticRenderFns } from "./treatmentpartreturn.vue?vue&type=template&id=600274d4&scoped=true"
import script from "./treatmentpartreturn.vue?vue&type=script&lang=js"
export * from "./treatmentpartreturn.vue?vue&type=script&lang=js"
import style0 from "./treatmentpartreturn.vue?vue&type=style&index=0&id=600274d4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600274d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('600274d4')) {
      api.createRecord('600274d4', component.options)
    } else {
      api.reload('600274d4', component.options)
    }
    module.hot.accept("./treatmentpartreturn.vue?vue&type=template&id=600274d4&scoped=true", function () {
      api.rerender('600274d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/return/treatmentpartreturn.vue"
export default component.exports